export const hideWriteCTA = [
  'latest',
  'news-updates',
  'pss-research',
  'pss-research2',
  'nhsengland',
  'cancer-focus-group',
  'cancer-health-insurance-focus-group',
  'stress-sleep-research',
  'positivewellbeing',
];

export const hideRespondImageUpload = [
  'menshealth-penishealth',
  'theibsnetwork',
];
